<div class="mini-container">
  <div class="mini-container-header">
    <div class="mini-container-header-info">
      <img src="assets/icons/icon_package_green.svg" *ngIf="isDefaultContainer" />
      <img src="assets/icons/icon_container_green.svg" *ngIf="!isDefaultContainer" />

      <h3>
        {{ (isDefaultContainer ? "LABELS.COLOADING" : "LABELS.CONTAINER") | translate }}
        <strong *ngIf="!isDefaultContainer">{{ containerType?.displayName }}</strong>
      </h3>
    </div>

    <div class="mini-container-header-actions" *ngIf="!isDefaultContainer">
      <img src="assets/icons/icon_add_blue.svg" (click)="create.emit()" />
    </div>
  </div>

  <div class="mini-container-body">
    <div class="mini-container-body-pricing-row total">
      {{ (isDefaultContainer ? "LABELS.TOTAL_BOOKED" : "LABELS.OPEN_BOX") | translate }}:
      {{ getTotalBooked() | currency : "USD" : "symbol" : "1.2-2" }}
    </div>
  </div>
</div>
